/*
 *
 * ActivityPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'activityPage';
export const initialState = {
    availability: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        progressLoaded: 0,
        progressTotal: 0,
        res: null,
    },
    cart: {
        submitErrorMessage: '',
        submitIsLoading: false,
    },
    is404: false,
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: true,
        res: null,
    },
    params: {
        id: '',
        slug: '',
    },
    recommends: {
        res: [],
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
    },
    stories: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    config: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    unavailable: {
        /**
         * [formattedDate] = {
         *        days: [],
         *        isLoading: boolean,
         *        isError: boolean,
         *        errorMessage: string,
         *        dateEndOfRequest: formatted date string,
         * }
         */
    },
    userImages: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: true,
        res: null,
    },
    add_tripflex: -1,
    availabilityCalendar: {
        isValidTicket: false,
        payload: false,
    },
};

export const unavailableDefaults = {
    days: [],
    isLoading: false,
    isError: false,
    isLoaded: false,
    errorMessage: '',
    dateEndOfRequest: 0,
};

/* eslint-disable no-param-reassign, default-case */
function activityPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            case ActionTypes.SET_ADD_TO_CART:
                draft.cart.submitErrorMessage = action.errorMessage;
                draft.cart.submitIsLoading = action.isLoading;
                return draft;
            case ActionTypes.RESET_CONTENTS:
                draft.availability = initialState.availability;
                draft.cart = initialState.cart;
                draft.is404 = initialState.is404;
                draft.page = initialState.page;
                draft.recommends = initialState.recommends;
                draft.stories = initialState.stories;
                draft.unavailable = initialState.unavailable;
                draft.add_tripflex = initialState.add_tripflex;
                return draft;
            // Unavailable
            case ActionTypes.RESET_UNAVAILABLE:
                draft.unavailable = {};
                return draft;
            case ActionTypes.FETCH_UNAVAILABLE_STARTED:
                draft.unavailable[action.formattedDate] =
                    draft.unavailable[action.formattedDate] || unavailableDefaults;
                draft.unavailable[action.formattedDate].isLoading = true;
                draft.unavailable[action.formattedDate].isError = false;
                draft.unavailable[action.formattedDate].errorMessage = '';
                return draft;
            case ActionTypes.FETCH_UNAVAILABLE_SUCCESSFULLY:
                draft.unavailable[action.formattedDate] =
                    draft.unavailable[action.formattedDate] || unavailableDefaults;
                draft.unavailable[action.formattedDate].isLoading = false;
                draft.unavailable[action.formattedDate].isLoaded = true;
                draft.unavailable[action.formattedDate].days = action.formattedDays;
                draft.unavailable[action.formattedDate].dateEndOfRequest =
                    action.formattedDateEndOfRequest;
                return draft;
            case ActionTypes.FETCH_UNAVAILABLE_FAILED:
                draft.unavailable[action.formattedDate] =
                    draft.unavailable[action.formattedDate] || unavailableDefaults;
                draft.unavailable[action.formattedDate].isLoading = false;
                draft.unavailable[action.formattedDate].isError = true;
                draft.unavailable[action.formattedDate].errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_UNAVAILABLE_CANCELLED:
                draft.unavailable[action.formattedDate] =
                    draft.unavailable[action.formattedDate] || unavailableDefaults;
                draft.unavailable[action.formattedDate].isLoading = false;
                return draft;
            case ActionTypes.SET_UNAVAILABLE_IS_LOADED:
                draft.unavailable[action.formattedDate] =
                    draft.unavailable[action.formattedDate] || unavailableDefaults;
                draft.unavailable[action.formattedDate].isLoaded = action.isLoaded;
                return draft;
            // Page
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            // Stories
            case ActionTypes.FETCH_STORIES_STARTED:
                draft.stories.isLoading = true;
                draft.stories.isError = false;
                draft.stories.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_STORIES_SUCCESSFULLY:
                draft.stories.isLoading = false;
                draft.stories.isLoaded = true;
                draft.stories.res = action.res;
                return draft;
            case ActionTypes.FETCH_STORIES_FAILED:
                draft.stories.isLoading = false;
                draft.stories.isError = true;
                draft.stories.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_STORIES_CANCELLED:
                draft.stories.isLoading = false;
                return draft;
            case ActionTypes.SET_STORIES_IS_LOADED:
                draft.stories.isLoaded = action.isLoaded;
                return draft;
            // Recommends
            case ActionTypes.FETCH_RECOMMENDS_STARTED:
                draft.recommends.isLoading = true;
                draft.recommends.isError = false;
                draft.recommends.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY:
                draft.recommends.isLoading = false;
                draft.recommends.isLoaded = true;
                draft.recommends.res = action.res;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_FAILED:
                draft.recommends.isLoading = false;
                draft.recommends.isError = true;
                draft.recommends.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_CANCELLED:
                draft.recommends.isLoading = false;
                return draft;
            case ActionTypes.SET_RECOMMENDS_IS_LOADED:
                draft.recommends.isLoaded = action.isLoaded;
                return draft;
            // Availability
            case ActionTypes.FETCH_AVAILABILITY_STARTED:
                draft.availability.isLoading = true;
                draft.availability.isError = false;
                draft.availability.errorMessage = '';
                draft.availability.progressLoaded = 0;
                draft.availability.progressTotal = 0;
                return draft;
            case ActionTypes.FETCH_AVAILABILITY_SUCCESSFULLY:
                draft.availability.isLoading = false;
                draft.availability.isLoaded = true;
                draft.availability.res = action.res;
                return draft;
            case ActionTypes.FETCH_AVAILABILITY_FAILED:
                draft.availability.isLoading = false;
                draft.availability.isError = true;
                draft.availability.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_AVAILABILITY_CANCELLED:
                draft.availability.isLoading = false;
                return draft;
            case ActionTypes.SET_AVAILABILITY_IS_LOADED:
                draft.availability.isLoaded = action.isLoaded;
                return draft;
            case ActionTypes.SET_AVAILABILITY_PROGRESS:
                draft.availability.progressTotal = action.total;
                draft.availability.progressLoaded = action.loaded;
                return draft;
            // userImages
            case ActionTypes.FETCH_USER_IMAGES_STARTED:
                draft.userImages.isLoading = true;
                draft.userImages.isError = false;
                draft.userImages.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY:
                draft.userImages.isLoading = false;
                draft.userImages.isLoaded = true;
                draft.userImages.res = action.res;
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_FAILED:
                draft.userImages.isLoading = false;
                draft.userImages.isError = true;
                draft.userImages.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_CANCELLED:
                draft.userImages.isLoading = false;
                return draft;
            case ActionTypes.SET_USER_IMAGES_IS_LOADED:
                draft.userImages.isLoaded = action.isLoaded;
                return draft;
            // Config
            case ActionTypes.FETCH_CONFIG_STARTED:
                draft.config.isLoading = true;
                draft.config.isError = false;
                draft.config.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_CONFIG_SUCCESSFULLY:
                draft.config.isLoading = false;
                draft.config.isLoaded = true;
                draft.config.res = action.res;
                return draft;
            case ActionTypes.FETCH_CONFIG_FAILED:
                draft.config.isLoading = false;
                draft.config.isError = true;
                draft.config.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_CONFIG_CANCELLED:
                draft.config.isLoading = false;
                return draft;
            case ActionTypes.SET_CONFIG_IS_LOADED:
                draft.config.isLoaded = action.isLoaded;
                return draft;
            //Add_tripflex
            case ActionTypes.CHANGE_ADD_TRIPFLEX:
                draft.add_tripflex = action.add_tripflex;
                return draft;
            //availability calendar
            case ActionTypes.SET_IS_VALID_TICKET:
                draft.availabilityCalendar.isValidTicket = action.isValidTicket;
                return draft;
            case ActionTypes.SET_PAYLOAD:
                draft.availabilityCalendar.payload = action.payload;
                return draft;
            default:
                return draft;
        }
    });
}

export default activityPageReducer;
